<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span>処理中です...</span>
        </v-overlay>
        
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
                <v-card-text>
                    <pdf-upload-component @triggerEvent="changeFile" @triggerEvent2="deleteDbFile" :db-file-list="items" ></pdf-upload-component>
                    <v-container>
                        <v-row>
                            <v-col cols="12" xl="3">
                                <badge-component color="red" tile content="必 須">
                                    <label-component>タイトル</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <validation-provider v-slot="{ errors }" name="stateContractName" rules="required|max:50">
                                    <v-text-field outlined clearable v-disabled-icon-focus :error-messages="errors" v-model="stateContractName" background-color="white"></v-text-field>
                                </validation-provider>
                            </v-col>
                        </v-row>
                        <!--<v-row>-->
                        <!--    <v-col cols="12" xl="3">-->
                        <!--        <badge-component tile content="任 意">-->
                        <!--            <label-component>メモ</label-component>-->
                        <!--        </badge-component>-->
                        <!--    </v-col>-->
                        <!--    <v-col cols="12" xl="7">-->
                        <!--        <validation-provider v-slot="{ errors }" name="stateContractDestinationName" rules="max:50" >-->
                        <!--            <v-text-field outlined clearable v-disabled-icon-focus :error-messages="errors" v-model="stateContractDestinationName" background-color="white"></v-text-field>-->
                        <!--        </validation-provider>-->
                        <!--    </v-col>-->
                        <!--</v-row>-->
                    </v-container>
                </v-card-text>
            </v-card>
            <div class="text-center pt-2">
                <v-btn color="red" class="white--text" :disabled="!isValid" @click="next">次へ</v-btn>
            </div>
        </validation-observer>
    </div>
</template>

<script>
    import axios from 'axios';
    import { max } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    extend('max', {
        ...max,
        message: '{length} 文字以内でご入力ください',
    });
    
    export default {
        components: {
              ValidationProvider,
              ValidationObserver,
        },
        props: {
            model: Object,
            dbFileList: Array,
        },
        data() {
            return {
                files: [],
                items: [],
                objectIds: [],
                stateContractName: '',
                stateContractDestinationName: '',
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
            };
        },
        // 初期表示のデータ
        created : function() {
            this.items = this.dbFileList;
            this.stateContractName = this.model.template_name;
            this.stateContractDestinationName = this.model.memo;
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            isValid: {
                get() {
                    if (!this.stateContractName) {
                        return false;
                    }
                    if (this.stateContractName != null && this.stateContractName.length > 50) {
                        return false;
                    }
                    
                    if (this.items.length <= 0 && this.files.length <= 0) {
                        return false;
                    }
                    
                    return true;
                },
                set(value) {
                    
                }
            }
        },
        methods: {
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.save();
                    if (result) {
                        window.location = "address";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            
            // 保存
            save: async function() {
                var self = this;
                let result = false;
                await this.$refs.observer.validate().then( async function(validOk) {
                    if(validOk) {
                        let formData = new FormData();
                        for(let i = 0; i < self.files.length; i++){
                            formData.append('files[]', self.files[i][0].file);
                        }
                        //JSON文字列に変換
                        formData.append('contractItems', JSON.stringify(self.items));
                        formData.append('contract_name', self.stateContractName);
                        formData.append('memo', self.stateContractDestinationName);
                        
                        let config = {
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        };
                        
                        await axios
                            .post('info', formData, config)
                            .then(function (response) {
                                if (response.data.success) {
                                    result = true;
                                } 
                                else {
                                    result = false;
                                    if (response.data.message) {
                                        self.message.text = response.data.message;
                                    } else {
                                        self.message.text = "保存処理に失敗しました";
                                    }
                                    self.message.success = false;
                                }
                            })
                            .catch(function (response) {
                                result = false;
                                console.log(response);
                                self.message.text = "保存処理に失敗しました";
                                self.message.success = false;
                            }
                        );
                    } else {
                        result = false;
                        self.message.text = "入力項目に不備があります";
                        self.message.success = false;
                    }
                });
                return result;
            },
            changeFile: function(value) {
                this.files = value;
            },
            
            deleteDbFile: function(index) {
                this.$delete(this.items, index);
            }
        },
    };
</script>
